//my edits
import { useState, useEffect, useCallback, useMemo } from "react";
import callAPI from "../utils/callAPI";

export function useDashboards() {
  const [dashboards, setDashboards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDashboardList = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callAPI("GET", "get_dashboard_list/", "", "");
      
      if (response.msg === "success") {
        setDashboards(response.data || []);
      } else {
        throw new Error(response.msg || "Failed to fetch dashboards");
      }
    } catch {
      setError("Network error");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboardList();
  }, [fetchDashboardList]);

  return useMemo(() => ({
    dashboards,
    loading,
    setLoading,
    error,
    fetchDashboardList,
  }), [dashboards, loading, error, fetchDashboardList]);
}
